import { Paths } from 'src/constants/paths'

import { buildAuth0LogoutUrl } from './buildAuth0LogoutUrl'

/**
 * `/logout/complete`に居る場合はAuth0の`/v2/logout`へリダイレクトし、`true`を返す。
 *
 * この画面はAuth0へ中継するだけで何も描画しないため、SPAを起動する前に呼び出す。
 * 起動してから`LogoutCompleteScreen`のEffectで遷移すると、初期化とレンダリングを一通り
 * 済ませてから離脱することになり、ログアウトの途中で余計な画面読み込みが挟まって見える。
 */
export const redirectFromLogoutComplete = (): boolean => {
  if (window.location.pathname !== Paths.LogoutComplete) {
    return false
  }

  window.location.replace(buildAuth0LogoutUrl() ?? Paths.Login)

  return true
}
